module.exports = __webpack_public_path__ + "static/media/dummy.3961eab7.png";